// extracted by mini-css-extract-plugin
export default {"header":"header_header__RZQYQ","nav":"header_nav__n24hS","link":"header_link__dU5GB","activeLink":"header_activeLink__dQyfH","wrapper":"header_wrapper__vteUK"};